<template>
  <div class="app-container goods-record-list">
    <div class="goods-record-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="goods-record-list-filter-value" v-model.trim="search.goodsName" @keyup.enter.native="searchChange" placeholder="商品名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="goods-record-list-filter-value" placeholder="商品分类" v-model="search.goodsType" clearable filterable size="small">
              <el-option
                v-for="item in goodsTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="goods-record-list-filter-value" placeholder="核销类型" v-model="search.redeemType" clearable size="small">
              <el-option
                v-for="item in redeemTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="goods-record-list-filter-value" placeholder="商品状态" v-model="search.status" clearable size="small">
              <el-option
                v-for="item in memberGoodsStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="goods-record-list-filter-value" v-model.trim="search.memberName" @keyup.enter.native="searchChange" placeholder="兑换人昵称或姓名" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="goods-record-list-filter-value" v-model.trim="search.unionId" @keyup.enter.native="searchChange" placeholder="兑换人员工编号" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="goods-record-list-filter-value" v-model.trim="search.orderId" @keyup.enter.native="searchChange" placeholder="订单号" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="goods-record-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="goods-record-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class = "member-goods-record-list-container">
      <avue-crud ref="crud"
                 :option="memberGoodsRecordTableOption"
                 :data="tableData"
                 :page="page"
                 :table-loading="tableLoading"
                 @current-change="handleCurrentChange"
                 @size-change="handleSizeChange"
                 @sort-change="handleSortChange">

        <template slot="goodsInfo" slot-scope="scope">
          <div class="goods-preview">
            <div class="goods-cover-image" v-if="scope.row.goodsInfo.coverImg" v-viewer>
              <img :src="scope.row.goodsInfo.coverImg">
            </div>
            <a href="javascript:void(0);" @click="toGoodsDetail(scope.row.goodsId);"
                class="goods-record-list-container-button">
              {{scope.row.goodsInfo.name}}
            </a>
          </div>
        </template>
        <template slot="redeemType" slot-scope="scope">
          {{ scope.row.redeemType.label }}
        </template>
        <template slot="status" slot-scope="scope">
          {{ scope.row.status.label }}
        </template>
        <template slot="nickname" slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.memberId);"
              class="goods-record-list-container-button">
            {{scope.row.memberInfo.nickname}}</a>
        </template>
        <template slot="menuLeft">
          <el-button @click="handleExport()"
                     size="small"
                     type="primary"
                     :loading="exportLoading"
                     icon="el-icon-download">{{ exportName }}
          </el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <div class="operate-menu">
            <el-button size="mini" type="text" icon="el-icon-view" @click="handleView(scope.row)" v-if="permissions.member_goods_record_detail">查看</el-button>
            <el-tooltip placement="top" :content="getToolTipContent(scope.row)" :disabled="isDisabledToolTip(scope.row)" v-if="isShowEntryCourierBtn(scope.row)">
              <div>
                <el-button
                  size="mini"
                  type="text"
                  :icon="scope.row.courierNumber ? 'el-icon-edit' : 'el-icon-plus'"
                  :disabled="!isDisabledToolTip(scope.row)"
                  @click="entryCourierInfo(scope.row)"
                  >{{ scope.row.courierNumber ? '修改快递信息' : '录入快递信息' }}
                </el-button>
              </div>
            </el-tooltip>
          </div>
        </template>

      </avue-crud>
    </basic-container>
    <el-dialog
      :visible.sync="entryCourierInfoDialog"
      @close="closeEntryCourierInfoDialog"
      :close-on-click-modal="false"
      width="30%"
      class="handle-dialog">
        <el-form ref="entryCourierInfoFrom" :model="entryCourierInfoFrom" :rules="rules">
            <el-form-item prop="courierCompany">
              <el-label >快递公司:</el-label>
              <el-input type="text" placeholder="请输入快递公司名称" v-model="entryCourierInfoFrom.courierCompany" clearable></el-input>
            </el-form-item>
            <el-form-item prop="courierNumber">
              <el-label >快递单号:</el-label>
              <el-input type="text" placeholder="请输入快递单号" v-model="entryCourierInfoFrom.courierNumber" clearable></el-input>
            </el-form-item>
            <div class="handle-dialog-footer">
              <el-button class="handle-dialog-footer-cancel" @click="closeEntryCourierInfoDialog">取消</el-button>
              <el-button type="primary" class="handle-dialog-footer-save" @click="handleEntryCourierInfo">确定</el-button>
            </div>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchMemberGoodsRecordPage, entryCourierInfo, exportMemberGoodsRecord } from '@/api/mall/record';
import { fetchGoodsTypeList } from '@/api/mall/type';
import { memberGoodsRecordTableOption, memberGoodsStatusOptions } from '@/const/crud/mall/record';
import { redeemTypeOptions } from '@/const/crud/mall/goods';
import { goodsRedeemTypesEnum, memberGoodsStatusEnum } from '@/common/enums/mallTypeEnum';
import { exporting } from '@/util/exportUtil'

export default {
  data () {
    return {
      memberGoodsRecordTableOption,
      memberGoodsStatusOptions,
      redeemTypeOptions,
      goodsTypeOptions: [],
      search: {
        current: 1,
        size: 10,
        status: null,
        goodsName: "",
        goodsType: null,
        redeemType: null,
        memberName: "",
        unionId: "",
        orderId: "",
        sortField: "",
        sortPolicy: "",
      },
      tableData:[],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableLoading: false,
      entryCourierInfoDialog: false,
      entryCourierInfoFrom: {
        id: null,
        courierCompany: '',
        courierNumber: '',
      },
      rules: {
        courierCompany: [
          { required: true, message: '快递公司不能为空', trigger: 'blur' },
          { max: 50, message: '长度不超过 50 个字符', trigger: 'blur' }
        ],
        courierNumber: [
          { required: true, message: '快递单号不能为空', trigger: 'blur' },
          { max: 50, message: '长度不超过 50 个字符', trigger: 'blur' }
        ]
      },
      exportName: "导出",
      exportLoading: false,
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  async activated() {
    await this.getGoodsTypeOptions();
    this.getList();
  },
  async created() {
    await this.getGoodsTypeOptions();
    this.getList();
  },
  methods: {
    getList() {
      let params = this.getParams();
      this.tableLoading = true;
      fetchMemberGoodsRecordPage(params).then(response => {
        this.tableData = this.formatData(response.data.data.records);
        this.page.total = response.data.data.total;
        this.tableLoading = false;
      })
    },
    formatData(records) {
      if (records && records.length > 0) {
        records.forEach(function(record, index) {
          if (!record.status) {
            record.goodsInfo.redeemType = { label: '其他', value: -1 }
          } else {
            record.status = memberGoodsStatusOptions.find(item => item.value == record.status)
          }
          record.goodsInfo.name = record.goodsInfo.name || "--"
          record.goodsTypes = record.goodsInfo.goodsTypes || "--"
          if (!record.goodsInfo.redeemType) {
            record.redeemType = { label: '其他', value: -1 }
          } else {
            record.redeemType = redeemTypeOptions.find(item => item.value === record.goodsInfo.redeemType)
          }
          record.nickname = record.memberInfo.nickname || "--"
          record.realname = record.memberInfo.realname || "--"
          record.unionId = record.memberInfo.unionId || "--"
          record.statusComment = record.statusComment || "--"
          record.goodsTypes = record.goodsInfo.goodsTypes.map(item => {return item.typeName}).join('、');
        })
      }
      return records
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = this.search.size;
      this.search.current = 1;
    },
    getParams() {
      let params = {
        current: this.search.current,
        size: this.search.size
      }

      if (this.search.status)
        params.status = this.search.status;
      if (this.search.goodsName)
        params.goodsName = this.search.goodsName;
      if (this.search.goodsType && this.search.goodsType !== -1)
        params.goodsType = this.search.goodsType;
      if (this.search.redeemType)
        params.redeemType = this.search.redeemType;
      if (this.search.memberName)
        params.memberName = this.search.memberName;
      if (this.search.unionId)
        params.unionId = this.search.unionId;
      if (this.search.orderId)
        params.orderId = this.search.orderId;

      if (this.search.sortField)
        params.sortField = this.search.sortField;
      else
        params.sortField = "inserted_time"
      if (this.search.sortPolicy)
        params.sortPolicy = this.search.sortPolicy;
      else
        params.sortPolicy = "desc";
      return params;
    },
    toMemberDetail(id) {
      if (id){
        this.$router.push({
          path: `/upms/member/detail/${id}`,
        })
      } else {
        this.$message({
          showClose: true,
          message: '用户不存在',
          type: 'warning'
        })
      }
    },
    toGoodsDetail(id) {
      if (id){
        this.$router.push({
          path: `/mall/goods/detail/${id}`
        })
      } else {
        this.$message({
          showClose: true,
          message: '该商品不存在',
          type: 'warning'
        })
      }
    },
    handleView(row) {
      this.$router.push({
        path: `/mall/record/detail/${row.id}`
      })
    },
    entryCourierInfo(row) {
      this.entryCourierInfoFrom.id = row.id;
      this.entryCourierInfoFrom.courierCompany = row.courierCompany || '';
      this.entryCourierInfoFrom.courierNumber = row.courierNumber || '';
      this.entryCourierInfoDialog = true;
    },
    handleEntryCourierInfo() {
      this.$refs.entryCourierInfoFrom.validate((valid) => {
        if (!valid) return
        entryCourierInfo(this.entryCourierInfoFrom).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.entryCourierInfoDialog = false;
          this.getList();
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      })
    },
    closeEntryCourierInfoDialog() {
      this.$refs.entryCourierInfoFrom.clearValidate();
      this.entryCourierInfoDialog = false;
      this.entryCourierInfoFrom.id = null;
      this.entryCourierInfoFrom.courierCompany = '';
      this.entryCourierInfoFrom.courierNumber = '';
    },
    isShowEntryCourierBtn(row) {
      return this.permissions.courier_info_entry && row.redeemType.value === goodsRedeemTypesEnum.PHYSICAL_EXCHANGE.code;
    },
    getToolTipContent(row) {
      if (row.status.value === memberGoodsStatusEnum.HAS_CHANGED.code || row.status.value === memberGoodsStatusEnum.LOCKED.code) {
        return '用户尚未填写收货人信息';
      } else if (row.status.value === memberGoodsStatusEnum.CONFIRM_RECEIPT.code) {
        return '用户已确认收货';
      } else {
        return '暂无提示';
      }
    },
    isDisabledToolTip(row) {
      return row.redeemType.value === goodsRedeemTypesEnum.PHYSICAL_EXCHANGE.code &&
             (row.status.value === memberGoodsStatusEnum.NO_DELIVERED.code || row.status.value === memberGoodsStatusEnum.DELIVERED.code);
    },
    searchChange() {
      this.initPage();
      this.getList();
    },
    searchReset() {
      this.search.status = null;
      this.search.goodsName = "";
      this.search.goodsType = null;
      this.search.redeemType = null;
      this.search.memberName = "";
      this.search.unionId = "";
      this.search.orderId = "";
      this.searchChange();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.search.current = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.search.size = val;
      this.getList();
    },
    handleSortChange(val) {
      if (val.prop == "rewardValue") {
        this.search.sortField = "reward_value";
      } else if (val.prop == "insertedTime") {
        this.search.sortField = "inserted_time";
      } else {
        this.search.sortField = "";
      }
      if (val.order == 'ascending') {
        this.search.sortPolicy = "asc";
      } else if (val.order == 'descending') {
        this.search.sortPolicy = "desc";
      } else {
        this.search.sortPolicy = "";
      }
      this.getList();
    },
    async getGoodsTypeOptions() {
      const response = await fetchGoodsTypeList();
      if (Array.isArray(response.data.data)) {
        const type = response.data.data.map(x => {
          return {
            value: x.id,
            label: x.name
          }
        });
        this.goodsTypeOptions = [{value: -1, label: '全部'}].concat(type);
      }
    },
    handleExport() {
      let params = this.getParams()
      this.exportLoading = true
      this.exportName = "导出中..."
      exportMemberGoodsRecord(params).then(response => {
        if (response.status === 200 && response.data && response.data.data) {
          exporting(response.data.data, this.exportCallback)
        } else {
          this.exportLoading = false
          this.exportName = "导出"
          this.$message({
            message: '信息导出失败',
            type: 'warning',
            showClose: true,
          });
        }
      });
    },
    exportCallback(result) {
      this.exportLoading = false
      this.exportName = "导出"
      if (result) {
        this.$message({
          showClose: true,
          message: '导出完成',
          type: 'success'
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.goods-record-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
  .goods-preview {
    display: flex;
    align-items: center;
    .goods-cover-image {
      display: flex;
      width: fit-content;
      margin-right: 12px;
      cursor: pointer;
      img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        max-width: 100%;
      }
    }
  }
  .handle-dialog {
    display: flex;
    flex-direction: column;
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 50px 0px;
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
  }
  .operate-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    .el-tooltip {
      margin-left: 8px;
    }
  }
}
</style>
